import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import settingsStore from './settings';
import performanceStore from './performance';
import IntervalService from './../services/intervals';
import sessionStore from './session';
import { subscribeWithSelector } from 'zustand/middleware';
import muvikaAttrs from './../attrs';

const minTime = 30;

const initialState = {
  isPlaying: { isPlaying: false },
  currentTrack: null,
  from: { from: 0 },
  streamUrl: "",
  currentTime: 0,
  previewStreamUrl: "",
  currentVolume: { currentVolume: 0, doNotPropagate: false },
  isFading: false
};

const previewPlayerStore = create(subscribeWithSelector((set, get) => (
  {
    ...initialState,
    reset: () => {
      set(initialState);
    },
    softReset: () => {
      set({
        isPlaying: { isPlaying: false },
        currentTrack: null,
        currentTime: 0,
        streamUrl: "",
        previewStreamUrl: "",
        isFading: false,
        from: { from: 0 },
      });
    },
    setIsFading: (isFading) => {
      set({ isFading: isFading });
    },
    setVolume: (volume, doNotPropagate = false) => {
      console.log("setVolume", volume);
      set({ currentVolume: { currentVolume: volume, doNotPropagate: doNotPropagate } });
    },
    setIsPlaying: (isPlaying) => {
      console.log("setting isPlaying in store", isPlaying);
      set({ isPlaying: { isPlaying: isPlaying } });
    },
    setFrom: (from) => {
      set({ from: { from: from } });
    },
    setCurrentTime: (time) => {
      set({ currentTime: time });
    },
    getStreamUrl: (sessionToken, track) => {
      MuvikaService.getStreamUrl(sessionToken, track.track_id, 0, "normal", true)
        .then(function (res) {
          if (res.data.error) {
            console.log("cover player", res.data.error);
            set({ isPlaying: { isPlaying: false }, currentTrack: track, streamUrl: "", previewStreamUrl: "" });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            console.log("cover player", res.data.data);
            set({ previewStreamUrl: res.data.data.preview_url, isPlaying: { isPlaying: true }, currentTrack: track, streamUrl: res.data.data.url });
          }
        })
        .catch(function (err) {
          console.log("cover player", err);
          set({ isPlaying: { isPlaying: false }, currentTrack: track, streamUrl: "", previewStreamUrl: "" });
        });
    }
  })
));

export default previewPlayerStore;